// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"28":"certificate","177":"home","535":"login"}[chunkId] + "." + {"28":"0cb5497a","177":"470193d2","535":"23a3aaf2"}[chunkId] + ".css";
};